import { Link, useLocation } from "react-router-dom";
import { Phone, MessageSquareText, Search, DollarSign, Tag } from "lucide-react";
import { siteConfig } from "../config";

export default function MobileStickyBar() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;

  const item = (icon, label, href, testId, ext) => {
    const cls = "flex flex-col items-center justify-center gap-0.5 py-2 flex-1 text-[0.7rem] font-semibold";
    if (ext) {
      return (
        <a href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId}>
          {icon}
          <span>{label}</span>
        </a>
      );
    }
    if (href.startsWith("/")) {
      return (
        <Link to={href} className={cls} data-testid={testId}>
          {icon}
          <span>{label}</span>
        </Link>
      );
    }
    return (
      <a href={href} className={cls} data-testid={testId}>
        {icon}
        <span>{label}</span>
      </a>
    );
  };

  return (
    <div
      className="xl:hidden fixed bottom-0 left-0 right-0 z-[55] bg-[var(--ssc-navy)] text-white border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-sticky-bar"
    >
      <div className="flex items-stretch">
        {item(<Phone size={18} />, "Call", siteConfig.scott.phoneTel, "sticky-call")}
        {item(<MessageSquareText size={18} />, "Text Scott", siteConfig.scott.phoneSms, "sticky-text")}
        {item(<Search size={18} />, "Find One", "/find-me-a-vehicle", "sticky-find")}
        {item(<DollarSign size={18} />, "Payment", "/payment-help", "sticky-payment")}
        {item(<Tag size={18} />, "Trade", "/value-my-trade", "sticky-trade")}
      </div>
    </div>
  );
}
